import React, { useState, useEffect, useContext } from 'react'
import SegmentIndexView from './SegmentIndexView'

const SegmentIndexApp = () => {

  const [isUpdating, setIsUpdating] = useState(false);

  useEffect(() => {
    const handleBeforeUnload = (event) => {
      if (isUpdating) {
        const message = 'Estamos procesando tu solicitud. Por favor, espera unos segundos... No cierres o recargues la página.';
        event.returnValue = message;
        return message;
      }
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [isUpdating]);


  return (
    <SegmentIndexView
      setIsUpdating={setIsUpdating}
    />
  );
};

export default SegmentIndexApp;
